export const COST_CENTRE_LIST_PATH = '/costcentre/totals/list';
export const COST_CENTRE_LIST_BY_PERIOD_PATH = '/costcentre/totals/listByPeriod';
export const COST_CENTRE_TOTALS_BY_ID_PATH = '/costcentre/:ccId/totals';
export const COST_CENTRE_MASS_DISTRIBUTION_PATH =
  '/costcentre/distribution/massDistribution';

export const COST_CENTRE_MOVE_PATH = '/costcentre/move/:id';
export const COST_CENTRE_CREATE_PATH = '/costcentre/create';
export const COST_CENTRE_EDIT_PATH = '/costcentre/:id';
